import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    subscription: null,
  },
  reducers: {
    setCredentials(state, action) {
      const { user, token } = action.payload;

      state.user = user;
      state.token = token;
    },
    updateUser: (state, action) => {
      const { user } = action.payload;

      state.user = user;
    },
    logOut: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setCredentials, updateUser, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
